
import CompletedService from "../section/completedservicepage/completedservice";
export default function CompletedServicePage() {
  return (
    <div className="h-full">
        <CompletedService/>
    </div>
  )
}